import ArrowCircleDown from "@/assets/icons/arrow-circle-down.svg?react";
import { formatVariacaoPercentual } from "../../home.format";
import styles from "./variation-badge.module.scss";

interface VariationBadgeProps {
  /** Variação em pontos percentuais; negativa é o resultado desejado. */
  value: number;
  /** Complemento após a variação, como "vs orçamento". */
  suffix?: string;
  testId: string;
}

/**
 * Variação percentual do protótipo: a seta circular verde do Figma seguida do
 * valor.
 *
 * A seta é a única exceção ao texto branco da Home, por isso vem do próprio
 * desenho do Figma em vez do PrimeIcons. A alta reaproveita o mesmo traçado
 * girado — o círculo é simétrico —, e o sentido continua legível pelo sinal no
 * texto, nunca só pela cor.
 */
export function VariationBadge({ value, suffix, testId }: VariationBadgeProps) {
  const isDown = value < 0;
  const direction = isDown ? "queda" : value > 0 ? "alta" : "estável";

  return (
    <span className={styles.badge} data-testid={testId}>
      <ArrowCircleDown
        className={[styles.icon, isDown ? "" : styles.iconUp].filter(Boolean).join(" ")}
        role="img"
        aria-label={direction}
      />
      <span className={styles.value}>{formatVariacaoPercentual(value)}</span>
      {suffix ? <span>{suffix}</span> : null}
    </span>
  );
}
